import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import '../inputs.scss';


const PromocodeInput = ({
    placeholder = 'Промокод',
    fillWidth = false,
    hasError = false,
    onBlur = () => {},
    errorText = '',
    inputRef,
    value,
    onChange,
}) => {
    const labelClasses = classNames({
        'input--has-float-label': true,
        'input-error-container': true,
        promocode: true,
        'fill-width': fillWidth,
    });

    const inputClasses = classNames({
        'input input--promocode': true,
        'has-error': hasError,
    });

    return (
        <label htmlFor="promocode" styleName={labelClasses}>
            <input
                styleName={inputClasses}
                type="text"
                id="promocode"
                name="promocode"
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                ref={inputRef}
                placeholder=" "
            />
            <div styleName="input__label">{placeholder}</div>
            {hasError && <div styleName="input-error">{errorText}</div>}
        </label>
    );
};

export default PromocodeInput;

PromocodeInput.propTypes = {
    placeholder: PropTypes.string,
    inputRef: PropTypes.shape({
        current: PropTypes.shape({}),
    }).isRequired,
    fillWidth: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    hasError: PropTypes.bool,
    errorText: PropTypes.string,
};

